module.exports = __webpack_public_path__ + "static/media/black_dragon_classic.29a22cea.webp";